<script setup lang="ts">
import type { AlertProps } from '@/types/components/AlertComponent'

defineProps<Partial<AlertProps>>()
</script>
<template>
    <div :class="`snackbar is-${type}`">
        {{ message }}
    </div>
</template>

<style scoped lang="scss">
.snackbar {
    &:deep(.alert-type.is-danger) {
        white-space: pre;
        display: block;
    }
}
</style>
